import { createRoute, redirect } from '@tanstack/react-router'
import { store } from 'store/store'

import OrderYarcheCreatePage from '../pages/OrderYarcheCreatePage/OrderYarcheCreatePage'
import { orderRoute } from './OrderRoute'
import { orderYarcheGuestCreateRoute } from './OrderYarcheGuestCreateRoute'

export const orderYarcheCreateRoute = createRoute({
  beforeLoad: async () => {
    const { token } = store.getState().authReducer
    if (!token) {
      throw redirect(orderYarcheGuestCreateRoute)
    }
  },
  getParentRoute: () => orderRoute,
  component: () => <OrderYarcheCreatePage />,
  path: '/create-yarche'
})
